import { render, staticRenderFns } from "./MenuListOrderArea.vue?vue&type=template&id=5d8b44d4&scoped=true&"
import script from "./MenuListOrderArea.vue?vue&type=script&lang=js&"
export * from "./MenuListOrderArea.vue?vue&type=script&lang=js&"
import style0 from "./MenuListOrderArea.vue?vue&type=style&index=0&id=5d8b44d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8b44d4",
  null
  
)

export default component.exports